import { mountSearchFilterPopup } from './search-filter-mount';
import { initHeroSearchSubmission } from './hero-search-submit';
function init() {
    initHeroSearchSubmission();
    const root = document.documentElement;
    const header = document.querySelector('.header');
    const detailBar = document.querySelector('.listing-fixed-bar');
    const actions = document.querySelector('.listing-top-bar');
    function wrapToolbar(element, className) {
        if (element.parentElement.classList.contains(className)) return element.parentElement;
        const bar = document.createElement('div');
        bar.className = 'hm-site-toolbar ' + className;
        element.before(bar);
        bar.append(element);
        return bar;
    }
    if (actions && detailBar) {
        root.classList.add('hm-has-detail-scrollbar');
        detailBar.classList.add('hm-detail-scrollbar');
    }
    const filters = document.querySelector('#listFilterForm .page-filter-wrap');
    const filterBar = filters ? wrapToolbar(filters, 'hm-list-filter-bar') : null;
    const seller = document.querySelector('.listing-sidebar-wrap');
    function updateOffsets() {
        root.style.setProperty('--hm-header-height', `${header?.getBoundingClientRect().height || 0}px`);
        root.style.setProperty('--hm-detail-bar-height', `${detailBar?.getBoundingClientRect().height || 0}px`);
        root.style.setProperty('--hm-filter-height', `${filterBar?.getBoundingClientRect().height || 0}px`);
        root.style.setProperty('--hm-seller-height', `${seller?.getBoundingClientRect().height || 0}px`);
    }
    updateOffsets();
    if (window.ResizeObserver) {
        const observer = new ResizeObserver(updateOffsets);
        [header, detailBar, filterBar, seller].filter(Boolean).forEach(el => observer.observe(el));
    }
    window.addEventListener('resize', updateOffsets, { passive: true });
    const fallback = document.getElementById('hm-mobile-filter-fallback');
    if (fallback && !document.getElementById('vue-search-filter')) {
        fallback.id = 'vue-search-filter';
        fallback.hidden = false;
        mountSearchFilterPopup();
    }
    document.addEventListener('keydown', event => {
        if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('.hm-currency-symbols[data-fancybox]')) {
            event.preventDefault();
            event.target.click();
        }
    });
    let locating = false;
    document.addEventListener('click', event => {
        const link = event.target.closest('[data-hm-nearby-listings]');
        if (!link) return;
        event.preventDefault();
        if (locating) return;
        const text = window.HM_NAV_I18N || {};
        const failed = error => {
            locating = false;
            link.removeAttribute('aria-busy');
            window.UI?.toast('warning', text.locationTitle, error?.code === 1 ? text.locationDenied : text.locationFailed);
        };
        if (!navigator.geolocation) { failed(); return; }
        locating = true;
        link.setAttribute('aria-busy', 'true');
        navigator.geolocation.getCurrentPosition(position => {
            const url = new URL(link.href);
            url.searchParams.set('lat', String(position.coords.latitude));
            url.searchParams.set('lng', String(position.coords.longitude));
            url.searchParams.set('radius', '5');
            url.searchParams.set('radius_mode', 'radius');
            window.location.assign(url.toString());
        }, failed, { enableHighAccuracy: true, timeout: 15000, maximumAge: 60000 });
    });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
else init();
